export default __webpack_public_path__ + "static/media/new-landing-background.d34f2375.svg";